/**
 * NxsApiClient -- HTTP client for /api/v1/nxs.
 * NXS transactions and balance queries.
 *
 * @module infrastructure/api/NxsApiClient
 */

import { ApiBase } from './ApiBase.js';

const BASE = '/api/v1/nxs';

export const NxsApiClient = {
  async getTransactions(userId, limit = 50) {
    const q = userId ? `?user_id=${encodeURIComponent(userId)}&limit=${limit}` : `?limit=${limit}`;
    return ApiBase.get(`${BASE}/transactions${q}`);
  },

  async getBalances() {
    return ApiBase.get(`${BASE}/balances`);
  },

  async createTransaction({ userId, type = 'credit', amount, referenceType = 'mission', referenceId, description }) {
    return ApiBase.post(`${BASE}/transactions`, { userId, type, amount, referenceType, referenceId, description });
  }
};
